import dayjs from 'dayjs'

import { Nullable } from 'clickNgo/models/utils'

export const formatLastModifiedDate = (date: Nullable<Date>) => {
  if (!date) {
    return '-'
  }

  return dayjs(date).format('DD MMMM, YYYY, hh:mm A')
}
